export default "__VITE_ASSET__DM3y2GBb__"